<template>
  <div
    v-if="this.$store.state.loading"
    class="plan-loading"
  >
    <div>
      <img
        src="https://img.eduwill.net/Img2/Common/loading_wait.gif"
        alt="로딩중입니다."
      >
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style >
</style>